/**
 * @Author: v_jppjpeng
 * @Date: 2024-05-16 14:34:07
 * @Explain: xss - 处理
 */
import DOMPurify from 'dompurify';

/** 过滤html脚本 */
export const filteringHtmlScripts = (html: any) =>
  html &&
  DOMPurify.sanitize(html, {
    ADD_TAGS: ['a'], // 如果 `<a>` 标签被移除，需明确添加（可选）
    ADD_ATTR: ['target'], // 允许保留 `target` 属性
    ALLOWED_ATTR: ['href', 'target', 'rel'], // 明确允许的属性（可选，但更安全）
  });
